export default __webpack_public_path__ + "static/media/couleurs.ae05e615.png";